export class Market {
  roleId: number;
  marketId: number;
  marketName: string;
  marketCode: string;
  marketNameDisplay: string;
  hasPastDataRequest: boolean;
}
